export enum PublicProjectOverviewPreviewParams {
  previewUuid = "previewUuid",
  uuid = "uuid",
}
